<plyca-ui-dropdown
  [options]="options"
  [resetValue]="resetValue"
  [placeholder]="placeholder"
  (valueChange)="onValueChange($event)"
>
  <ng-template let-comment pTemplate="selectedItem">
    <span>
      <i
        *ngIf="comment.value.origin == 'inbox'"
        style="font-size: 1.5em"
        class="fas fa-user-tie"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="comment.value.origin == 'substitution'"
        style="font-size: 1.5em"
        class="fas fa-user-friends"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="comment.value.origin == 'general'"
        style="font-size: 1.5em"
        class="fas fa-comment"
        aria-hidden="true"
      ></i>
    </span>
    <span class="ml-2" [innerHTML]="comment.label"></span>
  </ng-template>
  <ng-template let-comment pTemplate="item">
    <span>
      <i
        *ngIf="comment.value.origin == 'inbox'"
        style="font-size: 1.5em"
        class="fas fa-user-tie"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="comment.value.origin == 'substitution'"
        style="font-size: 1.5em"
        class="fas fa-user-friends"
        aria-hidden="true"
      ></i>
      <i
        *ngIf="comment.value.origin == 'general'"
        style="font-size: 1.5em"
        class="fas fa-comment"
        aria-hidden="true"
      ></i>
    </span>
    <span class="ml-2" [innerHTML]="comment.label"></span>
  </ng-template>
</plyca-ui-dropdown>
